import type { IconSvgObject } from './types';

const MouseRightClick06Icon: IconSvgObject = [
  ["path", { d: "M10.5 5.5V2M10.5 12V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.5 22C16.5 22 18 17.49 18 12C18 6.50998 16.5 2 10.5 2C4.49993 2 3 6.50996 3 12C3 17.49 4.49993 22 10.5 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 12L3 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M11 5.5H10C9.44772 5.5 9 5.94772 9 6.5V8C9 8.55228 9.44772 9 10 9H11C11.5523 9 12 8.55228 12 8V6.5C12 5.94772 11.5523 5.5 11 5.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M19 3L19.5 2M20 5.5L21 6", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "4" }]
];

export default MouseRightClick06Icon;
